import React from "react";
import EnquiryForm from "@/components/EnquiryForm";
import { Package, Wrench, Satellite, LayoutDashboard, RefreshCw, Headphones, Sparkles, School, Truck, Car, ShieldCheck } from "lucide-react";

const SERVICES = [
  { icon: Package, title: "GPS Device Supply", desc: "Genuine GPS trackers for personal, commercial and fleet vehicles." },
  { icon: Wrench, title: "Professional Installation", desc: "Certified technicians install & configure devices on-site." },
  { icon: Satellite, title: "Vehicle Tracking", desc: "Real-time tracking with alerts, geofencing and route history." },
  { icon: LayoutDashboard, title: "Fleet Management", desc: "Enterprise dashboard with driver, fuel, and trip analytics." },
  { icon: RefreshCw, title: "Subscription Plans", desc: "Flexible monthly & yearly plans for tracking platform access." },
  { icon: ShieldCheck, title: "Device Replacement & Maintenance", desc: "AMC and quick replacement in case of hardware failure." },
  { icon: Headphones, title: "Technical Support", desc: "Multi-lingual support 7 days a week via phone & WhatsApp." },
  { icon: Sparkles, title: "Customized GPS Solutions", desc: "Sensor integrations, custom reports and API access on request." },
  { icon: School, title: "School & Bus Tracking", desc: "Parent app, RFID attendance and route deviation alerts." },
  { icon: Truck, title: "Transport & Logistics Fleets", desc: "Fuel monitoring, trip planning and driver scoring." },
  { icon: Car, title: "Personal Vehicle Security", desc: "Anti-theft, SOS and mobile app for car and bike owners." },
];

export default function Services() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="services-page">
      <div className="max-w-3xl">
        <div className="eyebrow">Our services</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">End-to-end GPS tracking services</h1>
        <p className="mt-4 text-slate-600">From hardware to installation, from live tracking to advanced fleet analytics — KSPB is your single partner for GPS technology in India.</p>
      </div>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICES.map((s) => (
          <div key={s.title} className="p-6 rounded-2xl border border-slate-200 bg-white tile-hover">
            <div className="w-11 h-11 rounded-xl bg-[#0A192F] text-white flex items-center justify-center">
              <s.icon className="w-5 h-5" />
            </div>
            <h3 className="font-heading font-semibold text-[#0A192F] mt-4">{s.title}</h3>
            <p className="text-sm text-slate-600 mt-1.5">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-16">
        <EnquiryForm title="Need a specific service?" subtitle="Tell us your requirement and our specialist will get back within 24 hours." enquiry_type="general" testIdPrefix="services-enquiry" />
      </div>
    </div>
  );
}
